<div class="team-publish-container" *ngIf="!processing && !draftAlert">
  <div class="row info-panel">
    <div *ngIf="showErrMsg" class="alert app-message alert-danger">
      <div><i class="error icon wi wi-cancel"></i></div>
      <div [innerHTML]="errMsg"></div>
      <div><button title="Close" type="button" class="btn-transparent close" (click)="showErrMsg = false">&times;</button></div>
    </div>
    <div *ngIf="showInfoMsg" class="alert app-message alert-info">
      <div><i class="info icon wi wi-info"></i></div>
      <div [innerHTML]="infoMsg"></div>
      <div><button title="Close" type="button" class="btn-transparent close" (click)="showInfoMsg = false">&times;</button></div>
    </div>
    <form #infoForm="ngForm">
      <div class="row">
        <div class="row col-xs-1">
          <p class="provatar-container">
            <img class="provatar-image" name="wm-project-provatar" [src]="artifactPublishDetails.icon">
          </p>
        </div>
        <div class="col-xs-10 publish-details">
          <div class="row form-group">
            <label class="publish-subheading">{{artifactPublishDetails.displayName}}</label>
          </div>
          <div class="row form-group">
            <label class="control-label col-md-4">{{locale.LABEL_ARTIFACT_CATEGORY}} <span class="team-required-field">*</span></label>
            <div class="col-md-7">
              <div class="form-control categories-container">
                <input type="text" id="query" name="query" [(ngModel)]="artifactPublishDetails.query" autocomplete="off" class="form-control" (focus)="showCategoriesList = true" (click)="showCategoriesList = true"/>
                <ul id="category_list" *ngIf="showCategoriesList" (click)="showCategoriesList = false;">
                  <li *ngFor= "let category of getCategories()" title="{{category}}" (click)="changeArtifactCategory(category)">
                    {{category}}
                  </li>
                </ul>
                <ul class="add-new-category" *ngIf="showCategoriesList">
                  <li>
                    <div>
                      <p>{{locale.LABEL_ADD_NEW}} <i placement="top" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_ARTIFACT_CATEGORY_VALIDATION}}" class="wm-icon wms wms-help help-text-icon"></i></p>

                      <input type="text"
                             class="form-control"
                             name="addNewCategory" #addNewCategory="ngModel"
                             [ngClass]="{'highlight' : !addNewCategory.pristine && !addNewCategory.valid}"
                             [(ngModel)]="artifactPublishDetails.newCategory"
                             [minlength]="3" [maxlength]="39" pattern="^[a-zA-Z][a-zA-Z0-9. _\-]+$" >

                      <button class="add-item" title="{{locale.LABEL_ADD}}" (click)="addNewArtifactCategory()" [disabled]="artifactPublishDetails.newCategory.length < 1 || (!addNewCategory.pristine && !addNewCategory.valid)">
                        <i class="wi wi-check"></i>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="control-label col-md-4">{{locale.LABEL_ARTIFACT_CURRENT_VERSION}}</label>
            <div class="col-md-8 current-version">
              <label class="control-label" *ngIf="!artifactPublishDetails.isNew">{{artifactPublishDetails.version}}</label>
              <label class="publish-text" *ngIf="artifactPublishDetails.isNew">{{locale.LABEL_ARTIFACT_NOT_YET_PUBLISHED}}</label>
            </div>
          </div>
          <div class="row form-group new-version-group">
            <label class="control-label col-md-4">{{locale.LABEL_ARTIFACT_NEW_VERSION}} <span class="team-required-field">*</span></label>
            <div class="col-md-7 new-version">
              <wms-typeahead name="newVersion" [editable]="true" dropdownClass="versions-typeahead-dropdown"
                             [placeholder]="locale.PLACEHOLDER_NEW_VERSION"
                             [ngClass]="{'invalid-input': !artifactPublishDetails.isValid }"
                             (onSelect)="setNewVersion($event)" (onClear)="unsetNewVersion()"
                             propertyName="version" groupBy="category"
                             [model]="artifactPublishDetails.newVersion"  [options]="artifactPublishDetails.suggestedVersions"
                             [modelType]="'string'" [updateValueOn]="'blur'" [disable]="artifactPublishDetails.isDraft"></wms-typeahead>
            </div>
            <i class="wms wms-help col-md-1" (click)="toggleTooltip()"></i>
            <div class="wms-help-panel-container" *ngIf="tooltipVisible">
              <div class="wms-help-panel">
                <div class="body" [innerHTML]="locale.MSG_HELP_SEMANTIC_VERSION"></div>
                <div class="footer">
                  <a [href]="locale.SEMANTIC_VERSION_DOC_LINK" target="_blank">{{locale.USER_GUIDE}}</a> <br>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="control-label col-md-4">{{locale.LABEL_ARTIFACT_DESCRIPTION}}</label>
            <textarea class="form-control col-md-7 noresize"
                      name="description"
                      [disabled]="true" rows="5"
                      [(ngModel)]="artifactPublishDetails.description">
            </textarea>
          </div>
          <div class="row form-group">
            <label class="control-label col-md-4">{{locale.LABEL_ARTIFACT_CHANGE_LOG}} <span class="team-required-field">*</span></label>
            <textarea class="form-control col-md-7"
                      [(ngModel)]="artifactPublishDetails.commitMsg"
                      name="commitMessage" [maxLength]="1000"
                      rows="5">
            </textarea>
          </div>
          <div *ngIf="artifactPublishDetails.artifactType !== 'PROJECTCORE'" class="row form-group">
            <label class="control-label col-md-4">{{locale.LABEL_ARTIFACT_DEPENDENCIES}}</label>
            <table class="wm-table col-md-7" *ngIf="dependencies.length">
              <colgroup>
                <col width="50"/>
                <col width="50"/>
              </colgroup>
              <tbody>
              <tr *ngFor="let dependency of dependencies">
                <td class="word-break dependency"><span>{{dependency.name}}</span></td>
                <td>{{dependency.version}}</td>
              </tr>
              </tbody>
            </table>
            <label class="publish-text"  *ngIf="!dependencies.length">{{locale.LABEL_ARTIFACT_NO_DEPENDENCIES}}</label>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="team-publish-container" *ngIf="!processing && draftAlert">
  <div class="summary">
    <div class="info-message info-details row">
      <span class="info-msg">{{locale.LABEL_PUBLISH_ARTIFACT_AS_DRAFT_ALERT}}</span>
    </div>
  </div>
</div>
